import { useSelector } from "react-redux";

export const PERMISSION_DEVICE_CONFIGS_DETAILS = "device-configs-details";

export const useHasPermission = (permission) => {
  const permissionsForRole = useSelector(
    (state) => state?.authSlice?.user?.user?.permissions,
  );
  return Boolean(permission && permissionsForRole?.includes(permission));
};

const ShowContent = (props) => {
  const permissionsForRole = useSelector(
    (state) => state?.authSlice?.user?.user?.permissions
  );

  const couldShow = permissionsForRole?.includes(props.permission);

  return couldShow ? props.children : null;
};

const ShowContentAny = ({ permissions = [], children }) => {
  const permissionsForRole = useSelector(
    (state) => state?.authSlice?.user?.user?.permissions
  );

  const couldShow = permissions.some((permission) =>
    permissionsForRole?.includes(permission),
  );

  return couldShow ? children : null;
};

export { ShowContent, ShowContentAny };
